// Provides AntD notification context with useNotification hook
import React, { createContext, useContext } from 'react';
import { notification as antdNotification, Tag, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const NotificationContext = createContext({ showNotification: () => {} });

const NotificationProvider = ({ children }) => {
    const [notificationApi, contextHolder] = antdNotification.useNotification();

    const showNotification = (
        type = 'info',
        message = 'Info',
        description = 'Notification Message',
        concernType = null,
        duration = 3,
        placement = 'bottomRight',
        onReload = null
    ) => {
        const descriptionContent = concernType ? (
            <>
                {description}
                <br />
                <Tag color="cyan" style={{ marginTop: 8, fontWeight: 'bold' }}>
                    Concerned Person Type: {concernType}
                </Tag>
            </>
        ) : description;

        const btn = onReload ? (
            <Button
                type="primary"
                size="small"
                icon={<ReloadOutlined />}
                onClick={() => {
                    onReload();
                    notificationApi.destroy();
                }}
            >
                Reload Now
            </Button>
        ) : null;

        notificationApi.open({ 
            type, 
            message, 
            description: descriptionContent, 
            duration, 
            placement,
            btn
        });
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {contextHolder}
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationProvider;
export const useNotification = () => useContext(NotificationContext);
